var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"markdown-view",domProps:{"innerHTML":_vm._s(_vm.rendered)}})
}
var staticRenderFns = []

export { render, staticRenderFns }